import { makeStyles } from "@fluentui/react-components";
/**
 * Hook to create and return the styles for the ScreenReaderOnly component.
 */ export const useScreenReaderOnlyStyles = makeStyles({
    root: {
        position: "absolute",
        width: "auto",
        height: "1px",
        padding: "0",
        margin: "-1px",
        overflow: "hidden",
        clip: "rect(0,0,0,0)",
        border: "0"
    }
});
